import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import useApiUrls from "../../useApiUrls";

const AddCategaroyDqr = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { getUrlByOperation } = useApiUrls();

  const [formData, setFormData] = useState({
    name: "",
    remark: "",
    dqrid: id || 0,
    dqrcategoryid: 0,
    addqr: "",
    imagewidth: "",
    imageheight: "",
    center: "",
    imagepositionx: "",
    imagepositiony: "",
    exampletext: "",
    fontfamily: "",
    fontcolor: "",
    fontsize: "",
    textpositionx: "",
    textpositiony: "",
    images: null,
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.images) {
      setMessage("Name and Image are required fields.");
      return;
    }

    
  const token = getCookie("token");
  const userid = getCookie("userid");

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null) {
        formDataToSend.append(key, formData[key]);
      }
    });

    try {
      setLoading(true);
      const DQRImagesInsert = getUrlByOperation("DQRImagesInsert");
      await axios.post(DQRImagesInsert, formDataToSend, {
        headers: {
          "X-Authorization": token,
          "UserId": userid,
          "Content-Type": "multipart/form-data",
        },
      });
      setMessage("Catalogue added successfully!");
      setTimeout(() => {
        navigate(`/showcatelog/${id}`);
      }, 3000);
    } catch (error) {
      console.error("Error adding Catalogue:", error);
      setMessage(`Failed to add Catalogue: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      setFormData((prevData) => ({
        ...prevData,
        images: file,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Add DQR Image</h1>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add DQR Image</h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="name"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="remark"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image</label>
                              <input
                                type="file"
                                className="form-control"
                                onChange={handleChange}
                                name="images"
                                required
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image Width</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.imagewidth}
                                onChange={handleChange}
                                placeholder="Enter image width"
                                name="imagewidth"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Image Height</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.imageheight}
                                onChange={handleChange}
                                placeholder="Enter image height"
                                name="imageheight"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="card-footer">
                          <button type="submit" className="btn btn-info" disabled={loading}>
                            {loading ? "Adding..." : "Add"}
                          </button>
                        </div>
                      </form>
                      {message && (
                        <div className="alert alert-info mt-3">{message}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AddCategaroyDqr;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
